import { DiscountModalProps } from './types'
import type { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { SignupModal } from '../SignupModal'
import { useDiscountModalStore } from './store'

export const DiscountModal: ShopifySectionComponent<DiscountModalProps> = ({
  data,
}) => {
  const { ...modalData } = data!

  const { isOpen, close } = useDiscountModalStore()

  return (
    <>
      <SignupModal
        data={{
          ...modalData,
          image: {
            src: modalData.image?.src,
          },
        }}
        open={isOpen}
        exclusive
        onOpenChange={(open) => !open && close()}
      />
    </>
  )
}
